<div class="premium-dialog-header">
  <div class="dialog-badge-icon dialog-badge-emerald">
    <mat-icon>restore</mat-icon>
  </div>
  <h2>{{ 'ADMIN.ORDER_NUMBER' | translate }} {{ order.transactionId }}</h2>
</div>
<div mat-dialog-content>
  @if (error) {
    <div class="dialog-error">
      <p> {{ 'DATA_ERRORS.ERROR0' | translate }} : {{ error }}</p>
    </div>
  }
  <p class="m-0">{{ 'ADMIN.RESTORE_MESSAGE' | translate }} : </p>
  <mat-radio-group [(ngModel)]="selectedState" class="flex flex-col">
    <mat-radio-button [value]="OrderState.WAIT_FILES">
      {{ 'order.admin.state1' | translate }}
    </mat-radio-button>
    @if (order.state !== OrderState.PROCESSING) {
      <mat-radio-button [value]="OrderState.PROCESSING">
        {{ 'order.admin.state2' | translate }}
      </mat-radio-button>
    }
  </mat-radio-group>
</div>
@if (progress) {
  <mat-progress-bar color="primary" mode="indeterminate"></mat-progress-bar>
}
<div mat-dialog-actions align="end">
  <button mat-stroked-button (click)="cancel()" [disabled]="progress">
    {{ 'ADMIN.CANCEL' | translate }}
  </button>
  <button mat-flat-button color="primary" (click)="edit()" [disabled]="progress">
    <mat-icon>restore</mat-icon>
    {{ 'restore' | translate }}
  </button>
</div>
